import React from "react";
import { Link } from "react-router-dom";
import { useBranding } from "../../context/BrandingContext";
import { getFooterStyles } from "../../theme/storeStyles";

export default function StoreFooter() {
  const { branding } = useBranding();
  const brand = branding?.brand_name || "KalkiBazaar";
  const styles = getFooterStyles(branding?.theme_preset);
  return (
    <footer
      className={`${styles.root} safe-pb safe-pl safe-pr`}
      data-testid="store-footer"
      data-theme-preset={branding?.theme_preset || "kalki"}
    >
      <div className="px-6 md:px-12 lg:px-24 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className={styles.brandWrap}>{brand}</div>
          <p className={styles.brandText}>
            {branding?.tagline ||
              "A curated marketplace for timeless Indian couture. From heirloom Banarasi to contemporary bridal — sourced from independent ateliers."}
          </p>
        </div>
        <div>
          <div className={styles.colHeading}>Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link className={styles.linkClass} to="/shop/sarees">Sarees</Link></li>
            <li><Link className={styles.linkClass} to="/shop/lehengas">Lehengas</Link></li>
            <li><Link className={styles.linkClass} to="/shop/anarkalis">Anarkalis</Link></li>
            <li><Link className={styles.linkClass} to="/shop/jewelry">Jewelry</Link></li>
          </ul>
        </div>
        <div>
          <div className={styles.colHeading}>Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link className={styles.linkClass} to="/seller/onboard" data-testid="footer-seller-link">Sell on {brand}</Link></li>
            <li><span className={styles.linkClass}>The Craft Journal</span></li>
            <li><span className={styles.linkClass}>Contact</span></li>
            <li><span className={styles.linkClass}>Careers</span></li>
          </ul>
        </div>
        <div>
          <div className={styles.colHeading}>Stay in Touch</div>
          <p className={`${styles.brandText} mb-4`}>Receive first looks into bridal edits and atelier collabs.</p>
          <div className={styles.newsletterWrap}>
            <input
              className="flex-1 bg-transparent py-2 text-sm focus:outline-none placeholder:opacity-60"
              placeholder="you@email.com"
              data-testid="newsletter-input"
            />
            <button className={styles.newsletterBtn} data-testid="newsletter-submit">Join →</button>
          </div>
        </div>
      </div>
      <div className={`px-6 md:px-12 lg:px-24 py-4 ${styles.divider} flex flex-col md:flex-row justify-between items-center gap-2`}>
        <div className={styles.microCopy}>© {new Date().getFullYear()} {brand} · Crafted in India</div>
        <div className={`flex gap-6 ${styles.microCopy}`}>
          <Link className={styles.linkClass} to="/legal/terms" data-testid="footer-terms-link">Terms</Link>
          <Link className={styles.linkClass} to="/legal/privacy" data-testid="footer-privacy-link">Privacy</Link>
          <span>Shipping</span>
        </div>
      </div>
    </footer>
  );
}
